<template>
  <div class="container-item image-card mt-2 mb-4 mt-md-5 mb-md-1">  
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-9 col-xl-8 col-12">
        <div class="line-destacado"></div>
        <div class="embed-responsive embed-responsive-16by9 text-center">
          <iframe id="foco_video_minidoc_item" width="560" height="315" src="https://www.youtube.com/embed/Lla0VzKl2Fw?si=Q0Rbh8ygTenrVwkn" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div class="line-destacado"></div>
      </div>
    </div>    
  </div>
</template>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'SingleVideo',
    mixins: [images],
    props: {
      cardText: Object 
    }
  }
</script>